import { render, staticRenderFns } from "./PostsListImmo.vue?vue&type=template&id=5a828780&"
import script from "./PostsListImmo.vue?vue&type=script&lang=js&"
export * from "./PostsListImmo.vue?vue&type=script&lang=js&"
import style0 from "./PostsListImmo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports